export default {
  EBGCA_CROCODILE_MOVE: 'croc_move',
  EBGCA_CROCODILE_IDLE: 'croc_stop',
  EBGCA_CROCODILE_SHOW: 'croc_start',
  EBGCA_CROCODILE_HIDE: 'croc_end_bottom',
};
